import React from 'react';
import axios from 'axios';
import { getCookie } from 'utils/cookiesUtils';

export const AxiosDefaults = () => {
  axios.defaults.baseURL = process.env.REACT_APP_PAVUK_API_HOST;
  const authToken = getCookie('PAVUKAT');

  if (authToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
  }

  axios.defaults.headers.post['Content-Type'] = 'application/json';
  return <></>;
};
